import i18n from '@/shared/i18n';

/**
 * Shared labels for the optional import column-map step.
 * Keys live in the common namespace.
 */
export const importColumnMapLabels = () => ({
  check: i18n.t('importExport.columnMap.check'),
  mappingTitle: i18n.t('importExport.columnMap.title'),
  mappingHint: i18n.t('importExport.columnMap.hint'),
  mappingField: i18n.t('importExport.columnMap.field'),
  mappingSource: i18n.t('importExport.columnMap.source'),
  mappingSample: i18n.t('importExport.columnMap.sample'),
  mappingSkip: i18n.t('importExport.columnMap.skip'),
  mappingSubjectHint: i18n.t('importExport.columnMap.subjectHint'),
  mappingIncomplete: i18n.t('importExport.columnMap.incomplete'),
  inspecting: i18n.t('importExport.columnMap.inspecting'),
});
